import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOrgAssetWorkspacePath } from "@/features/assets/lib/get-org-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getOrgAssetWorkspacePath({
				orgId: params.orgId,
				assetId: params.assetId,
				tab: "form",
			}),
		});
	},
});
